/**
 * External Dependencies
 */
import 'jquery';
import * as VisibleProgress from 'dlg-mixins/js/VisibleProgress.js';
import * as targetToggle from 'dlg-mixins/js/targetToggle.jquery.js';
import anime from 'animejs/lib/anime.es.js';
import * as Swiper from 'swiper/swiper-bundle';
// import tailwindConfig from '../styles/tailwind-front.config.js';
import { parseResponsiveConfig, checkSize} from './TailwindResponsive.js';
import { debounce, parseQueryString, createQueryString, parseURL } from './utils.js';

$.formUtils.registerLoadedModule('phoneUS');

$.formUtils.addValidator({
    name : 'phoneUS',
    validatorFunction : function(phone_number) {
        var valid = false;
        phone_number = phone_number.replace( /\s+/g, "" );
        valid = phone_number.length > 9 && phone_number.match( /^(\+?1-?)?(\([2-9]([02-9]\d|1[02-9])\)|[2-9]([02-9]\d|1[02-9]))-?[2-9]\d{2}-?\d{4}$/ );

        return valid;
    },
    errorMessage : 'Veuillez entrer un numéro de téléphone.',
    errorMessageKey: 'badUSPhoneNumber'
});

let scrollAnim;
let nav_opened = false;
let gridCarousels = new Array();
let carousels = new Array();

// animejs only accepts cubic bezier if we camelcase
let easingDefault = tailwindTransitionTimingFunction.default.replace('cubic-bezier', 'cubicBezier');

function openCloseNav(_this) {
    let val = [0, $('.nav-wrap-inner').outerHeight()];
    if(nav_opened) { 
        val.reverse();
    }
    anime({
        targets: $('.nav-wrap').get(),
        height: val,
        duration: 200,
        easing: easingDefault,
        autoplay: true,
        complete: function() {
            // Remove height style to prevent nav to stay hidden on responsive
            if(!nav_opened) {
                $('.nav-wrap').removeAttr('style');
            }
        }
    });
    nav_opened = !nav_opened;

    $(_this).toggleClass('has-nav-opened');
    $('.navbar').toggleClass('has-nav-opened');
}

function scrollToHrefTarget(hash) {
    if(typeof hash !== 'undefined' && hash != "") {
        if(hash.indexOf('#target=') != -1){
            var params = parseQueryString(hash);
            if(typeof params.target != 'undefined'){
                params.offset = params.offset || getDefaultBannerOffset();
                params.focusAfter = params.focusAfter || null;
                return animeScroll(decodeURIComponent(params.target), params.offset, params.focusAfter);
            }
        }else if($(hash).length){
            params.offset = params.offset || getDefaultBannerOffset();
            params.focusAfter = params.focusAfter || null;
            return animeScroll(hash, params.offset, params.focusAfter);
        }
    }
    return false;
}

function animeScroll(hash, offset, focusAfter){
    try{
        var el = $(hash);
    }catch(e) {
        return false;
    }

    if(offset == undefined){
        offset = 0;
    }
    if(focusAfter == undefined){
        focusAfter = null;
    }
    if(el.length>0){
        var scroll_offset = $(document.body).scrollTop() + (el.offset().top - $(document.body).offset().top) - offset;
        // scroll_offset = Math.min($('.footer')[0].getBoundingClientRect().bottom, scroll_offset);
        
        // calculate duration against distance 
        // to make speed always the same
        var diff = Math.abs($(document.body).scrollTop() - scroll_offset);
        var timeSpeed = diff * 0.5;

        scrollAnim = anime({
            targets: 'html,body',
            scrollTop: scroll_offset,
            duration: timeSpeed,
            easing: easingDefault,
            complete: function(){
                var loc = '#target=' + encodeURIComponent(hash) + "&offset=" + offset;
                if(focusAfter){
                    if($(focusAfter).length > 0){
                        $(focusAfter).focus();
                        loc += "&focusAfter=" + focusAfter;
                    }
                }

                window.location.hash = loc;
                el.addClass('targeted-once');
            }
        });

        return true;
    }

    return false;
}

function getDefaultBannerOffset() {
    // this offset should not be hard-coded, but we can't pre-calculate the height of the header for now
    let config = {
        'offset' : 65,
        'md': {
            'offset': 92
        }
    };
    config = checkSize(config, tailwindScreens);
    return config['offset'];
}

function initMap(t) {
    var pos = t.attr('m-pos').split(',');
    var zoom = parseInt(t.attr('m-zoom'));
    var full = t.attr('m-full');

    if(!t.hasClass('inited')) {
                    
        var map = new google.maps.Map(t[0], {
            zoom: zoom,
            center: new google.maps.LatLng(pos[0], pos[1]),
            scrollwheel: false,
            navigationControl: false,
            mapTypeControl: false,
            scaleControl: false,
            draggable: false,
            disableDefaultUI: true,
            mapTypeId: google.maps.MapTypeId.ROADMAP
        });
        
        t.data('map', map);
        
        var marker = new google.maps.Marker({
            position: new google.maps.LatLng(pos[0], pos[1]),
            clickable: true,
            map: map,
            icon: {
                path: "M26.5,0.4C12.1,0.4,0.4,12.1,0.4,26.5c0,14.4,26.1,32.1,26.1,46.1c0-13.3,26.1-31.7,26.1-46.1 C52.6,12.1,40.9,0.4,26.5,0.4z M26.5,33.8c-4,0-7.3-3.3-7.3-7.3s3.3-7.3,7.3-7.3c4,0,7.3,3.3,7.3,7.3S30.5,33.8,26.5,33.8z",
                fillColor: t.attr('m-color'),
                fillOpacity: 1,
                anchor: new google.maps.Point(27, 74),
                strokeWeight: 0,
                scale: 0.75
            }
        });
        
        var golink = 'https://maps.google.com/?q=' + full;
        
        // if(isMobile) {
            
            map.addListener('click', function() {
                
                window.open(golink);
            
            });
        
        // }
        
        marker.addListener('click', function() {
            
            window.open(golink);
        
        });
        
        t.addClass('inited');
        
    } else if(t.data('map')) {
        
        var latLng = new google.maps.LatLng(pos[0], pos[1]);
        t.data('map').panTo(latLng);
        
    }

}

function onWindowSizeChange() {
    addRemoveMobileSwipers();
    addAbsoluteAnims();
}

function addRemoveMobileSwipers() {
    if(window.matchMedia('(min-width:' + tailwindScreens.lg + ')').matches) {
        if(gridCarousels.length > 0) {
            for(let i=0; i<gridCarousels.length; i++) {
                gridCarousels[i].destroy(true, true);
                gridCarousels.splice(i, 1);
                $('[data-swiper-parallax-opacity],[data-swiper-parallax-scale]').removeAttr('style');
            }
        }
        if(carousels.length > 0) {
            for(let i=0; i<carousels.length; i++) {
                carousels[i].destroy(true, true);
                carousels.splice(i, 1);
                // seems to have a problem with Swiper's
                // parallax effect and removal of the instance:
                // doesn't clean up it's style attributes
                $('[data-swiper-parallax-opacity],[data-swiper-parallax-scale]').removeAttr('style');
            }
        }
    }else{
         /**
         * Carrousels en mobile seulement
         */
        let carousels_els = document.querySelectorAll('.carrousel .swiper-container');
        for(let i=0; i<carousels_els.length; i++) {
            let _this = carousels_els[i];
            let loop = $(_this).attr('data-swiper-loop');

            if(typeof loop == 'undefined') {
                loop = false;
            }

            // let sliderBreakpoints = {};
            // sliderBreakpoints[parseInt(tailwindScreens.md)] = {
            //     spaceBetween: 96,
                // slidesPerView: 3.2,
                // watchOverflow:true,
            // };
            // sliderBreakpoints[parseInt(tailwindScreens.lg)] = {
            //     slidesPerView: 5,
            //     spaceBetween: 16,
            //     parallax: false,
            //     centeredSlides: false,
            //     watchOverflow:true,
            //     loop:false
            //     // direction:'vertical',
            // };

            carousels.push(new Swiper (_this, {
                // Optional parameters
                direction: 'horizontal',
                loop: loop,
                parallax: true,
                speed: 500,
                watchOverflow:true,
                slidesPerView: 2.4,
                autoHeight:true,
                spaceBetween: 12,
                centeredSlides: true,
                slideToClickedSlide: true,
                // spaceBetween: 0,
                // breakpoints: sliderBreakpoints,
                // navigation: {
                    // nextEl: '.swiper-button-next',
                    // prevEl: '.swiper-button-prev',
                // },
                // pagination: {
                //     el: '.swiper-pagination',
                //     type: 'bullets',
                //     clickable: true
                // },
                autoplay: false
                // autoplay: {
                    // delay: 8000,
                    // disableOnInteraction: true,
                // },
            }));
        }

        /**
         * Carrousels en grille, mobile seulement
         */
        let gridcarousels_els = document.querySelectorAll('.carrousel-grille .swiper-container');
        for(let i=0; i<gridcarousels_els.length; i++) {
            let _this = gridcarousels_els[i];
            // let slidesLength = _this.querySelectorAll('.swiper-slide').length;
            // let slideHeight = _this.querySelector('.swiper-slide').getBoundingClientRect().height;
            // _this.style.height=(Math.ceil(slidesLength/2)*(slideHeight + 24 )) +'px';

            // let sliderBreakpoints = {};
            // sliderBreakpoints[parseInt(tailwindScreens.md)] = {
            //     spaceBetween: 96,
                // slidesPerView: 3.2,
                // watchOverflow:true,
            // };

            // sliderBreakpoints[parseInt(tailwindScreens.lg)] = {
            //     slidesPerView: 2,
            //     slidesPerColumn: Math.ceil(slidesLength/2),
            //     spaceBetween: 24,
            //     parallax: false,
            //     centeredSlides: false,
            //     watchOverflow:true,
            //     loop:false
            //     // direction:'vertical',
            // };

            gridCarousels.push(new Swiper (_this, {
                // Optional parameters
                direction: 'horizontal',
                loop: true,
                parallax: true,
                speed: 500,
                watchOverflow:true,
                slidesPerView: 1.25,

                autoHeight:true,
                spaceBetween: 24,
                centeredSlides: true,
                // spaceBetween: 0,
                // breakpoints: sliderBreakpoints,
                // navigation: {
                    // nextEl: '.swiper-button-next',
                    // prevEl: '.swiper-button-prev',
                // },
                // pagination: {
                //     el: '.swiper-pagination',
                //     type: 'bullets',
                //     clickable: true
                // },
                autoplay: false
                // autoplay: {
                    // delay: 8000,
                    // disableOnInteraction: true,
                // },
            }));
        }
    }
}

function addAbsoluteAnims() {
    let absElements = $('.js-absolute-anim');
    absElements.each(function(index, el) {
        new VisibleProgress(el, true, 200);
        let config = parseResponsiveConfig(el);
        config = checkSize(config, tailwindScreens);

        let animConfig = {
            targets: el,
            easing: 'linear',
            duration: 5000,
            autoplay: false,
            loop: false
        };

        if(typeof config['padding-top-from'] !== 'undefined') {
            animConfig['paddingTop'] = [config['padding-top-from'], config['padding-top-to']];
        }
        if(typeof config['padding-bottom-from'] !== 'undefined') {
            animConfig['paddingBottom'] = [config['padding-bottom-from'], config['padding-bottom-to']];
        }
        if(typeof config['margin-top-from'] !== 'undefined') {
            animConfig['marginTop'] = [config['margin-top-from'], config['margin-top-to']];
        }
        if(typeof config['margin-bottom-from'] !== 'undefined') {
            animConfig['marginBottom'] = [config['margin-bottom-from'], config['margin-bottom-to']];
        }
        if(typeof config['translatey-from'] !== 'undefined') {
            animConfig['translateY'] = [config['translatey-from'], config['translatey-to']];
        }
        if(typeof config['width-from'] !== 'undefined') {
            animConfig['width'] = [config['width-from'], config['width-to']];
        }
        if(typeof config['backgroundcolor-from'] !== 'undefined') {
            animConfig['backgroundColor'] = [config['backgroundcolor-from'], config['backgroundcolor-to']];
        }
        if(typeof config['opacity-from'] !== 'undefined') {
            animConfig['opacity'] = [config['opacity-from'], config['opacity-to']];
        }


        el.animation = anime(animConfig);
        el.addEventListener('progress.vp', (ev) => {
            ev.currentTarget.animation.seek(ev.currentTarget.animation.duration * ev.detail.instance.progress);

            if(ev.detail.instance.progress >= 0.1) {
                $(ev.currentTarget).addClass('absolute-anim-done');
            }else {
                $(ev.currentTarget).removeClass('absolute-anim-done');
            }

            if(ev.detail.instance.progress >= 0.99) {
                $(ev.currentTarget).addClass('absolute-anim-end');
            }else {
                $(ev.currentTarget).removeClass('absolute-anim-end');
            }
        });
    });
    
}

((w, d) => {
    d.addEventListener('DOMContentLoaded', () => {
        if($('.gmaps')[0]){
            initMap($('.gmaps').first());
        }

        /**
         * Add black background to nav only if there's no slider at the top of the content
         */
        if(!$('.main > .slider:first-child').length) {
            $('.navbar').addClass('navbar-black');
        }

        /**
         * Appear animation
         */
        // Manual adding to nav
        $('.nav-main > li').addClass('js-anime-appear-el');
        $('.js-anime-appear').each(function(index, el) {
            el.done = false;
            let _this = $(el);
            new VisibleProgress(el);
            el.addEventListener('progress.vp', (ev) => {
                let _this = ev.currentTarget;
                if(_this.done == false && ev.detail.instance.rawProgress>=0.03) {
                    _this.done = true;
                    anime({
                        duration: 1000,
                        targets: $(_this).find('.js-anime-appear-el').get(),
                        translateX: [0, 0],
                        translateY: [-15, 0],
                        translateZ: [0, 0],
                        opacity: [0, 1],
                        easing: easingDefault,
                        delay: anime.stagger(200),
                        complete: function(anim) {
                            // remove style attribute
                            $(_this).find('.js-anime-appear-el').each(function(index, el) {
                                $(el).removeAttr('style');
                                $(el).addClass('has-appeared');
                            });
                        }
                    });
                }
            });
        });

        let sliders = document.querySelectorAll('.slider .swiper-container');
        for(let i=0; i<sliders.length; i++) {
            let _this = sliders[i];

            let sliderBreakpoints = {};
            // sliderBreakpoints[parseInt(tailwindScreens.md)] = {
            //     spaceBetween: 96,
            //     slidesPerView: 1.8
            // };
            sliderBreakpoints[parseInt(tailwindScreens.lg)] = {
                direction:'vertical',
            };
            // sliderBreakpoints[parseInt(tailwindScreens.xl)] = {
            //     slidesPerView: 3.25
            // };
            // sliderBreakpoints[parseInt(tailwindScreens.xxl)] = {
            //     slidesPerView: 4.5
            // };
            var mySwiper = new Swiper (_this, {
                // Optional parameters
                direction: 'horizontal',
                loop: true,
                parallax: true,
                speed: 500,
                watchOverflow:true,
                // slidesPerView: 1.15,
                // spaceBetween: 0,
                breakpoints: sliderBreakpoints,
                // navigation: {
                    // nextEl: '.swiper-button-next',
                    // prevEl: '.swiper-button-prev',
                // },
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets',
                    clickable: true
                },
                autoplay: {
                    delay: 8000,
                    disableOnInteraction: true,
                },
            });
        }

        

        // let animScrollXElements = document.querySelectorAll('.js-anime-scroll');
        // for (var i = 0; i < animScrollXElements.length; i++) {
        //     let _this = animScrollXElements[i];
        //     let reverse = _this.hasAttribute('data-reverse');
        //     let translateX = ['25%', '-25%'];
        //     if(reverse) {
        //         translateX.reverse();
        //     }
        //     new VisibleProgress(_this);
        //     _this.animation = anime({
        //         duration: 5000,
        //         autoplay: false,
        //         targets: _this,
        //         translateX: translateX,
        //         translateY: [0, 0],
        //         translateZ: [0, 0],
        //         easing: 'linear',
        //     });
        //     _this.addEventListener('progress.vp', (ev) => {
        //         ev.currentTarget.animation.seek(ev.currentTarget.animation.duration * ev.detail.instance.rawProgress);
        //     });
        // }
        
        /**
         * Add ajax pagination
         */
        let pagination = $('.nav-links');
        if(pagination.length > 0) {
            pagination.each(function(index, el) {
                let pages_wrapper = $(el);
                sage.current_page = parseInt(sage.current_page);
                pages_wrapper.html(sage.loadmore);
                let container = $('.js-load-more-container');

                $(document.body).on('click', '.js-load-more:not(.js-disabled)', function(ev) {
                    sage.current_page+=1;
                    $.ajax({
                        type: 'POST',
                        dataType: 'html',
                        url: sage.ajaxurl,
                        data: {
                            'cat': sage.cat,
                            'page': sage.current_page,
                            'post_type': sage.post_type,
                            's': sage.s,
                            'action': 'sage_load_more_ajax'
                        },
                        beforeSend : function () {
                            $('.js-load-more').addClass('js-disabled bg-gray-900 text-gray-300 hover:bg-gray-900 hover:text-gray-300');
                        },
                        success: function (data) {
                            var data = $(data).filter('article');
                            data.css('opacity', 0);
                            if (data.length) {
                                // save scrolltop
                                let scrollTopBefore = $(window).scrollTop();
                                container.append(data);
                                $(window).scrollTop(scrollTopBefore);
                                anime({
                                    targets: data.get(),
                                    translateY: [-15, 0],
                                    opacity: [0, 1],
                                    easing: easingDefault,
                                    delay: anime.stagger(150) // increase delay by 100ms for each elements.
                                });
                                $('.js-load-more').removeClass('js-disabled bg-gray-900 text-gray-300 hover:bg-gray-900 hover:text-gray-300');

                                let theurl = sage.archive_root;
                                let queryString = {};
                                if(sage.archive_root.indexOf('?') > -1) {
                                    let parts = sage.archive_root.split('?');
                                    queryString = parseQueryString('?' + parts[1]);
                                    queryString.paged = sage.current_page;
                                    theurl = parts[0];
                                }else{
                                    queryString.paged = sage.current_page;
                                }
                                theurl+=createQueryString(queryString);
                                history.pushState(sage, sage.post_type + ' page # ' + sage.current_page, theurl);
                                if(sage.current_page >= sage.max_page) {
                                    pages_wrapper.html(sage.noposts);     
                                }
                            } else {
                               pages_wrapper.html(sage.noposts);
                            }
                        },
                        error : function (jqXHR, textStatus, errorThrown) {
                            // $loader.html($.parseJSON(jqXHR.responseText) + ' :: ' + textStatus + ' :: ' + errorThrown);
                        },
                    });
                    ev.preventDefault();
                })
            });
        }
        
        // Open nav
        $('.js-toggle-nav').on('click touchend', function(ev) {
            openCloseNav(this);
            ev.preventDefault();
            ev.stopPropagation();
        });

        // Accordéons
        $("[data-accordion-target]").on('click touchend', function(ev){
            var target = $("[data-accordion='" + $(this).data('accordion-target') + "']");
            var height = $("[data-accordion-size='" + $(this).data('accordion-target') + "']").outerHeight();
            var closeOthers = $(this).data('accordion-close-others');
            var heightArr = ['0px', height + 'px'];
            if(closeOthers == undefined){
                closeOthers = true;
            }
            if(target.length > 0){
                // close all others
                if(closeOthers){
                    $("[data-accordion-target].open").not(this).each(function(index, el){
                        $(el).removeClass('open');
                        var closetarget = $("[data-accordion='" + $(el).data('accordion-target') + "']");
                        var closeheight = $("[data-accordion-size='" + $(el).data('accordion-target') + "']").outerHeight();
                        
                        anime({
                            targets: closetarget.get(0),
                            height: [closeheight, '0px'],
                            easing:easingDefault,
                            duration: 500
                        });
                    });
                }

                var animeobj = {
                    targets: target.get(0),
                    height: heightArr,
                    easing: easingDefault,
                    duration: 500
                };
                if($(this).hasClass('open')){
                    animeobj.height = heightArr.reverse();
                }else{
                    animeobj.complete = function(){
                        target.css('height', 'auto');
                    }
                }
                $(this).toggleClass('open');
                anime(animeobj);
                ev.stopPropagation();
                ev.preventDefault();
            }
        });
        // on domready, if open is found, let's open it
        $("[data-accordion-target].open").each(function(index, el) {
            var target = $("[data-accordion='" + $(this).data('accordion-target') + "']");
            target.css('height', 'auto');
        })

        // Search button manually activated
        $('.js-search a').each(function(index, el) {
            $(el).attr({
                "data-target":".search-bar",
                "data-event":"click",
                "data-prevent-default":"true",
                "data-stop-propagation":"true",
                "data-class-name":"search-bar-active transform translate-y-0"
            });
            $(el).addClass('js-target-toggle');
        });

        // Target toggle classes
        $('.js-target-toggle').targetToggle({
            afterToggle: function(ev, instance) {
                if(instance.target.hasClass('search-bar-active')) {
                    instance.target.find('input').focus().select();
                }
            }
        });


        /**
         * Banner squeeze
         */
        addAbsoluteAnims();
        addRemoveMobileSwipers();

        // add the appear classes to main nav and meta nav
        let debouncedResize = debounce(onWindowSizeChange);
        window.addEventListener('resize', debouncedResize);

        // Trigger visible progress on domready instead
        VisibleProgress.triggerScroll(window);


        /**
         * Animate scroll
         */
        // $('a.js-scrollto').on('click touchend', document.body, (ev) => {
        //     var _this = $(ev.currentTarget);
        //     var hash = _this.attr('href');
        //     // var offset = $('.banner').innerHeight();
        //     // var offset = 0;
        //     let offset = getDefaultBannerOffset();

        //     var focusAfter = null;

        //     if(_this.data('focus-after')){
        //         focusAfter = _this.data('focus-after');
        //     }

        //     if(_this.data('override-target')) {
        //         hash = _this.data('override-target');
        //     }

        //     if(_this.data('offset')) {
        //         offset+=_this.data('offset');
        //     }

        //     // if(App.animeScroll(hash, offset, focusAfter)){
        //     if(animeScroll(hash, offset, focusAfter)){
        //         ev.preventDefault();
        //     }
        // });
        // Clicking a #target link on the page itself
        $('a[href*="#"],a.js-scrollto').not('[data-accordion-target]').on('click touchend', document.body, function(ev) {
            let _this = $(ev.currentTarget);
            let url = _this.attr('href');
            let url_split = url.split(/\#(.+)/);
            let hash = '#' + url_split[1];
            // var offset = $('.banner').innerHeight();
            // var offset = 0;
            let offset = getDefaultBannerOffset();

            let focusAfter = null;

            if(_this.data('focus-after')){
                focusAfter = _this.data('focus-after');
            }

            if(_this.data('override-target')) {
                hash = _this.data('override-target');
            }

            if(_this.data('offset')) {
                offset+=_this.data('offset');
            }

            // if(App.animeScroll(hash, offset, focusAfter)){
            if(animeScroll(hash, offset, focusAfter)){
                ev.preventDefault();
            }
            // let url = $(ev.currentTarget).attr('href').split('#');
            // var hash = '#' + url[1];
            // if(scrollToHrefTarget(hash)) {
            //     if(w.matchMedia('(max-width:' + (parseInt(tailwindScreens.lg)-1) + 'px)').matches) {
            //         openCloseNav($('.js-toggle-nav').get(0)); // close nav mobile
            //     }
            //     ev.preventDefault();
            // }
        });

        // Contact form
        jQuery.validate({
            'errorElementClass':'shadow-error',
            'borderColorOnError': '',
            'modules': 'lang/fr'
        });
        var contactEnabled = true;
        $('form[name=contactform]').submit(function() {
            var obj = $(this);
            if(contactEnabled){
                contactEnabled = false;
                obj.find('button[type="submit"]').attr('disabled');
                $.ajax({
                    type: "POST",
                    url: sage.ajaxurl,
                    data: obj.serialize(),
                    dataType: 'json',
                    success: function(data) {
                        contactEnabled = true;
                        
                        if (data['response']) {
                            
                            //hAlerts("Message envoyé");
                            $('form[name=contactform]')[0].reset();
                            
                            $('form[name=contactform]').hide();
                            $('#contactconfirmation').show();
                            
                            
                        } else {
                            
                            obj.find('input, textarea').removeClass('shadow-error');
                            $.each(data.error, function(index, value) {
                                obj.find("#"+value).addClass('shadow-error');
                            });
                        }
                    }
                });
            }
            
            return false;
        });

        // Submenu - Fix character encodage issue
        $("#menusderoulant_1 select > option").each(function() {
            let originalTxt = this.text;
            let newText = originalTxt.replace("&#039;", "'");
            $(this).text(newText);
        });

        // Submenu
        $('.js-submenu').on('change', function(ev) {
            let selected = $("option:selected", this);

            $('.js-submenu-element').each(function(inde, el) {
                let target = $(el).data('target');
                $(target).addClass('hidden');
            });

            if(selected.hasClass('js-submenu-element')) {
                let target = $(selected).data('target');
                $(target).removeClass('hidden');

                ev.stopPropagation();
                ev.preventDefault();
            }
        });

        $('.js-selectlink').on('change', function(ev) {
            // check if hash and if hash is scrollable
            // let offset = getDefaultBannerOffset();
            // let focusAfter = null;

            let url = parseURL($(this).val());
            let target = $(this).find(':selected').data('menu-target');

            if($(this).val() && $(this).val()!='#'){
                // si le hash n'est pas vide et qu'on se trouve sur la même page, on tente de scroller vers l'ancre
                if(url.hash !=='' && url.hash !== '#' && (url.pathname == "" || url.pathname == window.location.pathname)) {
                    scrollToHrefTarget(url.hash);
                }else{
                    // some browsers block new window because of abusive popups
                    if(target == '_blank') {
                        if(!window.open($(this).val(), target)) {
                            window.location.href = $(this).val();
                        }
                    }else{
                        window.location.href = $(this).val();
                    }
                }

            }
        });

        // Newsletter
        $('.js-newsletter-error').hide();
        $('.js-newsletter-success').hide();
        $('form#newsletter').submit(function() {
            let obj = $(this);

            $.ajax({
                type: "POST",
                url: sage.ajaxurl,
                data: obj.serialize(),
                dataType: 'json',
                success: function(data) {
                    if(data.result.title == 'Member Exists') {
                        $('.js-newsletter-error').show().text(obj.data('alreadysubbed'));
                        $('.js-newsletter-success').hide();
                        $('#newsletter_email').addClass('shadow-error');
                    }else if(data.httpcode >= 400) {
                        $('.js-newsletter-error').show().text(obj.data('invalid'));
                        $('.js-newsletter-success').hide();
                        $('#newsletter_email').addClass('shadow-error');
                    }else{
                        $('#newsletter_email').removeClass('shadow-error');
                        $('.js-newsletter-error').hide();
                        $('.js-newsletter-success').show().text(obj.data('confirmation'));
                    }
                }
            });

            return false;
        });

    }); // end domcontentloaded

    


    // stop the animation if we try to scroll
    $(w).on('mousewheel wheel touchstart', function(ev){
        if(scrollAnim != null){
            scrollAnim.pause();
        }
    });

    $(w).on('load', () => {
        // Scroll on load if we have a hash
        var hash = w.location.hash;
        scrollToHrefTarget(hash);
    });
})(window, document);
